<template>
  <el-container v-title data-title="点餐排单" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学生点餐</el-breadcrumb-item>
                <el-breadcrumb-item>点餐排单</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-calendar v-model="selectedDate">
          <template v-slot:dateCell="{data}">
            <div style="margin:0; height:100%" :class="{'closed': notAvailableDays.indexOf(data.day) !== -1, 'notClosed': availableDays.indexOf(data.day) !== -1, 'blank': notAvailableDays.indexOf(data.day) === -1 && availableDays.indexOf(data.day) === -1}" @click="openWeekMenuDialog(data.day)">
              <p style="margin:0; text-align:center;">{{ data.day.split('-').slice(1).join('月') }}日</p>
              <p v-if="dateToBookDateRangeMap[data.day] != null" style="margin:0; text-align:center;">{{ dateToBookDateRangeMap[data.day] }}</p>
              <p v-if="dateToGoodsQtyMap[data.day] != null" style="margin:0; text-align:center;">{{ dateToGoodsQtyMap[data.day] }}</p>
            </div>
          </template>
        </el-calendar>
      </el-main>
      <!-- 弹窗页（菜单） -->
      <el-dialog
        :title="selectedDateString"
        :visible.sync="weekMenuDialogVisible"
        width="1373px"
        :before-close="handleClose"
        append-to-body>
        <el-row>
          <el-col :span="14">
            <el-tag>早餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.早餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="套餐名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入套餐名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenu(scope.row, 'goodsName')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="goodsDesc" label="套餐描述" width="560">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsDesc" placeholder="请输入套餐描述" @focus="saveInputCache(scope.row, 'goodsDesc')" @blur="modifyMenu(scope.row, 'goodsDesc')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="52">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenu(scope.row)" v-if="availableDays.indexOf(selectedDateString) !== -1">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag>午餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.午餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="套餐名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入套餐名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenu(scope.row, 'goodsName')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="goodsDesc" label="套餐描述" width="560">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsDesc" placeholder="请输入套餐描述" @focus="saveInputCache(scope.row, 'goodsDesc')" @blur="modifyMenu(scope.row, 'goodsDesc')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="52">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenu(scope.row)" v-if="availableDays.indexOf(selectedDateString) !== -1">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag>晚餐</el-tag>
            <el-table :data="typeToMenuGoodsListMap.晚餐" border style="width: 100%">
              <el-table-column prop="goodsName" label="套餐名称" width="165">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsName" placeholder="请输入套餐名称" @focus="saveInputCache(scope.row, 'goodsName')" @blur="modifyMenu(scope.row, 'goodsName')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="goodsDesc" label="套餐描述" width="560">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goodsDesc" placeholder="请输入套餐描述" @focus="saveInputCache(scope.row, 'goodsDesc')" @blur="modifyMenu(scope.row, 'goodsDesc')" :disabled="availableDays.indexOf(selectedDateString) === -1"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="52">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteMenu(scope.row)" v-if="availableDays.indexOf(selectedDateString) !== -1">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="1">
            <p></p>
          </el-col>
          <el-col :span="9">
            <el-col :span="10"><el-tag>套餐模板</el-tag></el-col>
            <el-col :span="14"><el-input v-model="filterGoodsName" placeholder="搜索套餐"></el-input></el-col>
            <el-table max-height="383" :data="schoolGoodsListForSelect" border style="width: 100%">
              <el-table-column prop="nameAndDescr" label="名称（描述）"></el-table-column>
              <el-table-column label="设置为" width="141">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.早餐 == null || typeToMenuGoodsListMap.早餐 != null && typeToMenuGoodsListMap.早餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addMenu(scope.row, '1')"  v-if="availableDays.indexOf(selectedDateString) !== -1">早餐</el-button>
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.午餐 == null || typeToMenuGoodsListMap.午餐 != null && typeToMenuGoodsListMap.午餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addMenu(scope.row, '2')"  v-if="availableDays.indexOf(selectedDateString) !== -1">午餐</el-button>
                  <el-button type="text" :disabled="typeToMenuGoodsListMap.晚餐 == null || typeToMenuGoodsListMap.晚餐 != null && typeToMenuGoodsListMap.晚餐.map(item => item.goodsId).indexOf(scope.row.id) != -1" @click="addMenu(scope.row, '3')"  v-if="availableDays.indexOf(selectedDateString) !== -1">晚餐</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12" style="height: 1px"></el-col>
          <el-col :span="12">
            <el-tag>统计（含预定中、预定成功、已完成、已退款，不含已取消）</el-tag>
            <el-table max-height="250" :data="statsList" border style="width: 100%">
              <el-table-column prop="partOfDayName" label="时段"></el-table-column>
              <el-table-column prop="goodsName" label="名称"></el-table-column>
              <el-table-column prop="goodsTypeName" label="类型" width="80"></el-table-column>
              <el-table-column prop="qty" label="份数" width="80"></el-table-column>
              <el-table-column prop="goodsPrice" :formatter="yuanOfGoodsPriceFormatter" label="单价" width="80"></el-table-column>
              <el-table-column prop="detailAmount" :formatter="yuanOfDetailAmountFormatter" label="总价" width="80"></el-table-column>
            </el-table>
          </el-col>
        </el-row> -->
      </el-dialog>
      <!-- 弹窗页（修改） -->
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          let todaysZero = new Date()
          // todaysZero.setHours(0, 0, 0, 0)
          return time.getTime() < todaysZero
        }
      },
      searchForm: {
        schoolId: null,
        status: ''
      },
      selectedDate: new Date(),
      availableDays: [],
      notAvailableDays: [],
      availableDateToMenuIdMap: {},
      dateToBookDateRangeMap: {},
      weekMenuDialogVisible: false,
      typeToMenuGoodsListMap: [],
      schoolGoodsList: [],
      schoolGoodsListForSelect: [],
      filterGoodsName: '',
      inputCache: {},
      dateToGoodsQtyMap: {}
    }
  },
  mounted () {
    // console.log('selectedDate: ' + this.selectedDate)
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      // this.getDateRange()
      setTimeout(() => {
        this.changeGridStyle()
      }, 10)
    }
  },
  methods: {
    search () {
      this.getRangeDays()
      this.getDateToGoodsQtyMap()
    },
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      this.getDateToGoodsQtyMap()
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getStudentCanteenScheduleList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getSchoolGoodsList()
              _this.getRangeDays()
              _this.getDateToGoodsQtyMap()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getRangeDays () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenu/getRangeDays', {
        schoolId: _this.searchForm.schoolId
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.selectedDate = res.data.data.today
            _this.availableDays = res.data.data.availableDateList
            _this.notAvailableDays = res.data.data.notAvailableDateList
            _this.availableDateToMenuIdMap = res.data.data.availableDateToMenuIdMap
            _this.dateToBookDateRangeMap = res.data.data.dateToBookDateRangeMap
            _this.getSchoolGoodsList()
            // console.log('_this.availableDays: ' + _this.availableDays)
            setTimeout(() => {
              _this.changeGridStyle()
            }, 10)
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    changeGridStyle () {
      let blankDomList = document.querySelectorAll('.blank')
      for (let dom of blankDomList) {
        dom.parentNode.parentNode.style.backgroundColor = '#FFFFFF'
        dom.parentNode.parentNode.style.opacity = '1'
        dom.parentNode.parentNode.style.color = '#000'
      }
      let closedDomList = document.querySelectorAll('.closed')
      for (let dom of closedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = dom.parentNode.parentNode.className.includes('is-today') ? '#FFC964' : '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
      let notClosedDomList = document.querySelectorAll('.notClosed')
      for (let dom of notClosedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
    },
    getSchoolGoodsList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/studentCanteenGoods/getListBySchoolId', {
        schoolId: _this.searchForm.schoolId
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200 && res.data.data != null) {
            _this.schoolGoodsList = res.data.data
            _this.schoolGoodsListForSelect = res.data.data
            // console.log('schoolGoodsList: ' + _this.schoolGoodsList)
          } else {
            this.$message.error(res.data.message)
          }
        }
        // if (res.data != null) {
        //   if (res.data.status === 200) {
        //     _this.typeToSchoolGoodsListMap = res.data.data
        //     if (_this.typeToSchoolGoodsListMap.菜品 != null) {
        //       _this.typeToSchoolGoodsListMap.cuisine = _this.typeToSchoolGoodsListMap.菜品
        //     }
        //     if (_this.typeToSchoolGoodsListMap.商品 != null) {
        //       _this.typeToSchoolGoodsListMap.goods = _this.typeToSchoolGoodsListMap.商品
        //     }
        //   }
        // }
      })
    },
    getTypeToMenuListMap () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenuDetail/getTypeToMenuListMap', {
        schoolId: _this.searchForm.schoolId,
        menuDate: _this.selectedDateString
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.typeToMenuGoodsListMap = res.data.data
            // console.log('_this.typeToMenuGoodsListMap: ' + JSON.stringify(_this.typeToMenuGoodsListMap))
            // Object.keys(_this.typeToMenuGoodsListMap).forEach(function (key) {
            //   _this.typeToMenuGoodsListMap[key].forEach(element => {
            //     if (element.goodsPrice != null && element.goodsPrice > 0) {
            //       element.yuanOfGoodsPrice = element.goodsPrice / 100
            //     }
            //     element.requiredItem = element.requiredItem != null && element.requiredItem === '1'
            //   })
            // })
            _this.weekMenuDialogVisible = true
          }
        }
      })
    },
    openWeekMenuDialog (date) {
      if (this.notAvailableDays.indexOf(date) === -1 && this.availableDays.indexOf(date) === -1) return
      let _this = this
      setTimeout(() => {
        _this.getTypeToMenuListMap()
        // _this.getStats()
      }, 10)
    },
    saveInputCache (menuDetail, propName) {
      if (this.inputCache[menuDetail.id] == null) {
        this.inputCache[menuDetail.id] = {}
      }
      this.inputCache[menuDetail.id][propName] = menuDetail[propName]
    },
    addMenu (schoolGoods, partOfDay) {
      if (this.availableDateToMenuIdMap[this.selectedDateString] === null) return
      let _this = this
      let weekMenuData = {}
      weekMenuData.schoolId = _this.searchForm.schoolId
      weekMenuData.weekMenuId = _this.availableDateToMenuIdMap[_this.selectedDateString]
      weekMenuData.menuDate = _this.selectedDateString
      weekMenuData.partOfDay = partOfDay
      weekMenuData.goodsId = schoolGoods.id
      weekMenuData.goodsName = schoolGoods.name
      weekMenuData.goodsDesc = schoolGoods.descr

      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenuDetail/add',
        weekMenuData
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.getTypeToMenuListMap()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    modifyMenu (menuDetail, propName) {
      let modifyData = {
        id: menuDetail.id
      }
      // console.log('menuDetail: ' + JSON.stringify(menuDetail))
      if (propName === 'goodsName') {
        if (menuDetail[propName] === '' || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        modifyData.goodsName = menuDetail.goodsName
      } else if (propName === 'goodsDesc') {
        if (menuDetail[propName] === '' || menuDetail[propName] === this.inputCache[menuDetail.id][propName]) {
          menuDetail[propName] = this.inputCache[menuDetail.id][propName]
          return
        }
        modifyData.goodsDesc = menuDetail.goodsDesc
      }
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenuDetail/update',
        modifyData
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    deleteMenu (menuDetail) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenuDetail/delete', {
        id: menuDetail.id
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            _this.getTypeToMenuListMap()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getDateToGoodsQtyMap () {
      let _this = this
      // _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenuDetail/getDateToGoodsQtyMap',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null) {
              _this.dateToGoodsQtyMap = res.data.data
            } else {
              _this.dateToGoodsQtyMap = {}
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
        // _this.loading = false
      })
    }
  },
  computed: {
    selectedDateString () {
      if (typeof this.selectedDate === 'string') {
        // console.log('this.selectedDate 2: ' + this.selectedDate)
        return this.selectedDate
      } else {
        // console.log('this.selectedDate 1: ' + this.selectedDate.toISOString().substring(0, 10))
        return this.selectedDate.toISOString().substring(0, 10)
      }
    }
  },
  watch: {
    selectedDate () {
      setTimeout(() => {
        this.changeGridStyle()
      }, 10)
    },
    filterGoodsName () {
      if (this.filterGoodsName.length === 0) {
        this.schoolGoodsListForSelect = this.schoolGoodsList
      } else {
        this.schoolGoodsListForSelect = []
        this.schoolGoodsList.forEach(element => {
          if (element.nameAndDescr != null && element.nameAndDescr.includes(this.filterGoodsName)) {
            this.schoolGoodsListForSelect.push(element)
          }
        })
      }
    }
  }
})
</script>
<style>
  .el-calendar-table td.current :hover {
    color: #FFF;
    background-color: #06a5f9;
  }
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
  .el-divider--horizontal {
    margin: 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/StudentCanteenMenu.vue